import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import "yet-another-react-lightbox/plugins/counter.css";

const floorPlansData = [
  {
    id: "258-east",
    size: "258 Sq.Yds",
    direction: "East",
    images: [
      { src: "/meadows-floor-plans-images/258East/258East.jpg", label: "3D View" },
      { src: "/meadows-floor-plans-images/258East/258E-ground.jpg", label: "Ground Floor" },
      { src: "/meadows-floor-plans-images/258East/258E-first.jpg", label: "First Floor" },
      { src: "/meadows-floor-plans-images/258East/258E-terrace.jpg", label: "Terrace Floor" }
    ]
  },
  {
    id: "308-east",
    size: "308 Sq.Yds",
    direction: "East",
    images: [
      { src: "/meadows-floor-plans-images/308East/308east.jpg", label: "3D View" },
      { src: "/meadows-floor-plans-images/308East/308east-ground.jpg", label: "Ground Floor" },
      { src: "/meadows-floor-plans-images/308East/308east-first.jpg", label: "First Floor" },
      { src: "/meadows-floor-plans-images/308East/308east-terrace.jpg", label: "Terrace Floor" }
    ]
  },
  {
    id: "358-east",
    size: "358 Sq.Yds",
    direction: "East",
    images: [
      { src: "/meadows-floor-plans-images/358east/358east.jpg", label: "3D View" },
      { src: "/meadows-floor-plans-images/358east/358east-ground.jpg", label: "Ground Floor" },
      { src: "/meadows-floor-plans-images/358east/358east-first.jpg", label: "First Floor" },
      { src: "/meadows-floor-plans-images/358east/358east-terrace.jpg", label: "Terrace Floor" }
    ]
  },
  {
    id: "408-east",
    size: "408 Sq.Yds",
    direction: "East",
    images: [
      { src: "/meadows-floor-plans-images/408east/408east.jpg", label: "3D View" },
      { src: "/meadows-floor-plans-images/408east/408east-ground.jpg", label: "Ground Floor" },
      { src: "/meadows-floor-plans-images/408east/408east-first.jpg", label: "First Floor" },
      { src: "/meadows-floor-plans-images/408east/408east-terrace.jpg", label: "Terrace Floor" }
    ]
  },
  {
    id: "258-west",
    size: "258 Sq.Yds",
    direction: "West",
    images: [
      { src: "/meadows-floor-plans-images/258West/258west.jpg", label: "3D View" },
      { src: "/meadows-floor-plans-images/258West/258west-ground.jpg", label: "Ground Floor" },
      { src: "/meadows-floor-plans-images/258West/258west-first.jpg", label: "First Floor" },
      { src: "/meadows-floor-plans-images/258West/258west-terrace.jpg", label: "Terrace Floor" }
    ]
  },
  {
    id: "308-west",
    size: "308 Sq.Yds",
    direction: "West",
    images: [
      { src: "/meadows-floor-plans-images/308west/308west.jpg", label: "3D View" },
      { src: "/meadows-floor-plans-images/308west/308west-ground.jpg", label: "Ground Floor" },
      { src: "/meadows-floor-plans-images/308west/308west-first.jpg", label: "First Floor" },
      { src: "/meadows-floor-plans-images/308west/308west-terrace.jpg", label: "Terrace Floor" }
    ]
  },
  {
    id: "358-west",
    size: "358 Sq.Yds",
    direction: "West",
    images: [
      { src: "/meadows-floor-plans-images/358west/358west.jpg", label: "3D View" },
      { src: "/meadows-floor-plans-images/358west/358west-ground.jpg", label: "Ground Floor" },
      { src: "/meadows-floor-plans-images/358west/358west-first.jpg", label: "First Floor" },
      { src: "/meadows-floor-plans-images/358west/358west-terrace.jpg", label: "Terrace Floor" }
    ]
  },
  {
    id: "408-west",
    size: "408 Sq.Yds",
    direction: "West",
    images: [
      { src: "/meadows-floor-plans-images/408west/408west.jpg", label: "3D View" },
      { src: "/meadows-floor-plans-images/408west/408west-ground.jpg", label: "Ground Floor" },
      { src: "/meadows-floor-plans-images/408west/408west-first.jpg", label: "First Floor" },
      { src: "/meadows-floor-plans-images/408west/408west-terrace.jpg", label: "Terrace Floor" }
    ]
  },
  {
    id: "780",
    size: "780 Sq.Yds",
    direction: "NA",
    images: [
      { src: "/meadows-floor-plans-images/780/780.png", label: "3D View" },
      { src: "/meadows-floor-plans-images/780/708-East-ground.jpg", label: "Ground Floor" },
      { src: "/meadows-floor-plans-images/780/708-east-first-floor.jpg", label: "First Floor" },
      { src: "/meadows-floor-plans-images/780/708-east-second-floor.jpg", label: "Terrace Floor" }
    ]
  }
];

const planGroups = [
  {
    direction: "East",
    plans: floorPlansData.filter((plan) => plan.direction === "East"),
  },
  {
    direction: "West",
    plans: floorPlansData.filter((plan) => plan.direction === "West"),
  },
  {
    direction: "General",
    plans: floorPlansData.filter((plan) => plan.direction === "NA"),
  },
];

export default function FloorPlansMeadows() {
  const [activeTab, setActiveTab] = useState(floorPlansData[0]?.id || "");
  const [open, setOpen] = useState(false);
  const [slides, setSlides] = useState([]);
  const [index, setIndex] = useState(0);

  const activeData = floorPlansData.find((d) => d.id === activeTab) || floorPlansData[0];
  const hasPlans = Boolean(activeData);

  const openGallery = (idx) => {
    if (!activeData) return;

    setSlides(activeData.images.map((img) => ({ src: img.src })));
    setIndex(idx);
    setOpen(true);
  };

  return (
    <section className="meadows-floorplans-section" id="meadows-floor-plans">
      <div className="container">
        <motion.div
          className="meadows-floorplans-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.6 }}
          transition={{ duration: 0.4 }}
        >
          <p className="meadows-floorplans-kicker">Villa Plans</p>
          <div className="meadows-floorplans-title-row">
            <h2 className="meadows-floorplans-title">Floor Plans</h2>
            {/* {hasPlans && (
              <div className="meadows-floorplans-current" aria-live="polite">
                <span>{activeData.size}</span>
                <small>{activeData.direction} Facing</small>
              </div>
            )} */}
          </div>
        </motion.div>

        {hasPlans ? (
          <div className="meadows-floorplans-shell">
            <aside className="meadows-floorplans-panel" aria-label="Floor plan options">
              {/* <div className="meadows-floorplans-panel-head">
                <span className="meadows-floorplans-panel-count">
                  {String(activePlanIndex).padStart(2, "0")}
                </span>
                <div>
                  <p>Selected Villa</p>
                  <h3>{activeData.size}</h3>
                </div>
              </div> */}

              <div className="meadows-floorplans-panel-meta">
                <span>{activeData.direction} Facing</span>
                <span>{activeData.images.length} Views</span>
              </div>

              <div className="meadows-floorplans-tabs">
                {planGroups.map((group) => (
                  <div className="meadows-floorplans-tab-column" key={group.direction}>
                    <h3 className="meadows-floorplans-tab-title">{group.direction}</h3>
                    {group.plans.map((tab) => (
                      <button
                        key={tab.id}
                        type="button"
                        className={`meadows-floorplans-tab ${activeTab === tab.id ? "is-active" : ""}`}
                        onClick={() => setActiveTab(tab.id)}
                        aria-pressed={activeTab === tab.id}
                      >
                        <span>{tab.size.replace(" Sq.Yds", "")}</span>
                        <small>Sq.Yds</small>
                      </button>
                    ))}
                  </div>
                ))}
              </div>
            </aside>

            <div className="meadows-floorplans-gallery">
              <div className="meadows-floorplans-gallery-head">
                <div>
                  <span className="meadows-floorplans-gallery-kicker">
                    {activeData.direction} Facing
                  </span>
                  <h3>{activeData.size}</h3>
                </div>
                <span className="meadows-floorplans-gallery-line" aria-hidden="true"></span>
              </div>

              <AnimatePresence mode="wait">
                <motion.div
                  key={activeTab}
                  className="meadows-floorplans-grid"
                  initial={{ opacity: 0, y: 18 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -18 }}
                  transition={{ duration: 0.2 }}
                >
                  {activeData.images.map((img, idx) => (
                    <motion.button
                      type="button"
                      className="meadows-floorplan-card"
                      key={`${img.label}-${img.src}`}
                      onClick={() => openGallery(idx)}
                      whileHover={{ y: -6 }}
                      transition={{ duration: 0.25 }}
                    >
                      <span className="meadows-floorplan-media">
                        <img
                          src={img.src}
                          alt={`${activeData.size} ${activeData.direction} ${img.label}`}
                          loading="lazy"
                        />
                        <span className="meadows-floorplan-badge">
                          {String(idx + 1).padStart(2, "0")}
                        </span>
                      </span>
                      <span className="meadows-floorplan-card-copy">
                        <span className="meadows-floorplan-label">{img.label}</span>
                        <span className="meadows-floorplan-action" aria-hidden="true">View</span>
                      </span>
                    </motion.button>
                  ))}
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        ) : (
          <div className="meadows-floorplans-empty">
            <p>Floor plans will be available soon.</p>
          </div>
        )}
      </div>

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={slides}
        index={index}
        plugins={[Zoom, Counter, Fullscreen]}
        imageFit="contain"
        zoom={{
          maxZoomPixelRatio: 4,
          zoomInMultiplier: 1.5,
          doubleTapDelay: 300,
          doubleClickDelay: 300,
        }}
        on={{ view: ({ index: currentIndex }) => setIndex(currentIndex) }}
        counter={{
          container: {
            style: { top: "16px", left: "16px", right: "auto", bottom: "auto", fontSize: "14px" },
          },
        }}
        styles={{ container: { backgroundColor: "rgba(20,15,10,0.96)" } }}
      />
    </section>
  );
}
